import { GRID_VIEW, REACTION_ICON_SIZES } from '../../pages/call/constants';

export function getReactionIconSizes(gridView: GRID_VIEW, isMainSlot: boolean, isMobile: boolean, slotsCount: number) {
    if (gridView === GRID_VIEW.DEFAULT) {
        if (isMobile) {
            return REACTION_ICON_SIZES.M;
        }

        if (slotsCount === 1) {
            return REACTION_ICON_SIZES.XL;
        }

        if (slotsCount < 5) {
            return REACTION_ICON_SIZES.L;
        }

        return REACTION_ICON_SIZES.M;
    }

    if (isMainSlot) {
        if (isMobile) {
            return REACTION_ICON_SIZES.M;
        }

        return REACTION_ICON_SIZES.XL;
    }

    if (isMobile) {
        return REACTION_ICON_SIZES.XS;
    }

    return REACTION_ICON_SIZES.S;
}
